import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/glamping-activities-and-amenities")({
  beforeLoad: () => {
    throw redirect({ href: "/onsite-experiences", statusCode: 301 });
  },
});
